export default "__VITE_ASSET__jF2Xh3d5__"